import styled from 'styled-components/macro';

export const Card = styled.div<{ border?: string }>`
  display: flex;
  flex-direction: column;

  border: ${({ border, theme }) => (border ? border : ` 1px dashed ${theme.colors.black_40}`)};
  border-radius: 4px;
  margin: ${({ theme }) => theme.spacing.zero_3} 0;
  background-color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
  }
`;

export const CardImage = styled.img<{ height?: string }>`
  width: 100%;
  height: ${({ height }) => height || '9rem'};
`;

export const CardTitle = styled.h4<{ margin?: string }>`
  margin: ${({ theme, margin }) => (margin ? margin : `0 0 ${theme.spacing.two} 0`)};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  text-align: center;
`;

export const CardDateContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.one};
`;

export const CardDate = styled.h5`
  color: ${({ theme }) => theme.colors.black_80};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;
export const CardBody = styled.div<{ padding?: string }>`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.one_2};
  padding: ${({ theme, padding }) => padding || theme.spacing.one};
`;

export const CardFooter = styled.div`
  display: flex;
`;

export const CardContentWrapper = styled.div<{ padding?: string }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${({ padding, theme }) => (padding ? padding : theme.spacing.one)};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    align-items: center;
    padding: 0.5rem;
    flex-basis: 100%;
  }
`;
